import React from 'react';
import {Route, Routes} from 'react-router-dom';
import Partnerships from '@/views/partnerships/Partnerships';
import CreatePartnershipAd from '@/views/partnerships/create-partnership-ad/CreatePartnershipAd';

export const PARTNERSHIPS_ROUTES = {
  MAIN: '',
  CREATE: 'create/:partnershipId',
};

function PartnershipsRoutes() {
  return (
    <Routes>
      <Route path={PARTNERSHIPS_ROUTES.MAIN} element={<Partnerships />} />
      <Route
        path={PARTNERSHIPS_ROUTES.CREATE}
        element={<CreatePartnershipAd />}
      />
    </Routes>
  );
}

export default PartnershipsRoutes;
